var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Popper } from 'react-popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
// - Import app components
import NotifyItem from 'components/notifyItem';
var styles = function (theme) {
    var _a;
    return ({
        root: {
            width: 360,
            maxWidth: 360,
            backgroundColor: '#efefef',
            minHeight: 376,
            display: 'flex',
        },
        noNotify: {
            color: '#888888',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            width: '100%'
        },
        popperClose: {
            pointerEvents: 'none'
        },
        popperOpen: {
            zIndex: 1,
            maxWidth: 500,
            overflowY: 'auto'
        },
        popper: {},
        overflowHidden: {
            overflow: 'hidden'
        },
        list: {
            maxHeight: 380,
            overflowY: 'auto',
            width: '98%'
        },
        fullPageXs: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0,
                overflowY: 'auto'
            },
            _a)
    });
};
/**
 * Create component class
 */
var NotifyComponent = /** @class */ (function (_super) {
    __extends(NotifyComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function NotifyComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.notifyItemList = function () {
            var _a = _this.props, info = _a.info, onRequestClose = _a.onRequestClose;
            var notifications = _this.props.notifications;
            var parsedDOM = [];
            if (notifications) {
                notifications.forEach(function (notification, key) {
                    var notifierUserId = notification.get('notifierUserId');
                    var userInfo = info.get(notifierUserId);
                    parsedDOM.push(React.createElement(NotifyItem, { key: key, description: notification.get('description', ''), fullName: (userInfo ? userInfo.fullName || '' : ''), avatar: (userInfo ? userInfo.avatar || '' : ''), id: key, isSeen: notification.get('isSeen', false), url: notification.get('url'), notifierUserId: notifierUserId, closeNotify: onRequestClose }));
                });
            }
            return parsedDOM;
        };
        // Defaul state
        _this.state = {};
        return _this;
        // Binding functions to `this`
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    NotifyComponent.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, open = _d.open, anchorEl = _d.anchorEl, onRequestClose = _d.onRequestClose, classes = _d.classes;
        var noNotify = (React.createElement("div", { className: classes.noNotify }, "All caught up! "));
        var items = this.notifyItemList();
        return (React.createElement(Popper, { placement: 'bottom-start', eventsEnabled: open, className: classNames((_a = {}, _a[classes.popperClose] = !open, _a), (_b = {}, _b[classes.popperOpen] = open, _b)) },
            React.createElement(ClickAwayListener, { onClickAway: onRequestClose },
                React.createElement(Grow, { in: open },
                    React.createElement(Paper, { className: classNames(classes.root, (_c = {}, _c[classes.overflowHidden] = !open, _c)), elevation: 4 }, items.length > 0 ? React.createElement(List, { className: classes.list }, items) : noNotify)))));
    };
    NotifyComponent.propTypes = {
        /**
         * It will be true if the notification is open
         */
        open: PropTypes.bool,
        /**
         * Pass anchor element
         */
        anchorEl: PropTypes.any,
        /**
         * Fire to close notificaion
         */
        onRequestClose: PropTypes.func,
        /**
         * If user's seen notification box or not (true/false)
         */
        isSeen: PropTypes.bool
    };
    return NotifyComponent;
}(Component));
export { NotifyComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    return {
        notifications: state.getIn(['notify', 'userNotifies']),
        info: state.getIn(['user', 'info'])
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NotifyComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/notify/NotifyComponent.tsx
// module id = 1091
// module chunks = 0 1 2 4 5 6 18 19 20 21